module.exports = __webpack_public_path__ + "static/media/amitkumar.de5a72e1.png";